import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { ADMIN_INVOICES_API_PATHS } from '../constants/invoices-app-paths.constant';

type DownloadInvoiceResponse = {
  signedUrl: string;
  fileName: string;
};

export function useDownloadInvoice() {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const download = useCallback(async (invoiceId: string): Promise<void> => {
    setIsLoading(true);
    try {
      const url = ADMIN_INVOICES_API_PATHS.GET_INVOICE_DOWNLOAD_URL(invoiceId);
      const response = await HttpClient.get<DownloadInvoiceResponse>(url);
      window.open(response.signedUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Erreur lors du téléchargement de la facture'),
        { variant: 'error' },
      );
    } finally {
      setIsLoading(false);
    }
  }, [enqueueSnackbar]);

  return { download, isLoading };
}
